import moment from "moment/moment";
import {ReportData} from "@/components/reports/scripts/types";
import {downloadFile} from "@/scripts/Common/helpers";

const downloadCsvReport = (data: ReportData) => {
  const itemName = buildFileName(data.fileName, data.dateFormat, data.startDate, data.endDate);
  downloadFile(data.content, itemName);
}

const buildFileName = (fileName: string, format: string, date1: string, date2: string | undefined) => {
  return !!date2
    ? `${fileName}_${formatDate(date1, format)}_${formatDate(date2, format)}.csv`
    : `${fileName}_${formatDate(date1, format)}.csv`;
}

const formatDate = (date: string, format: string) => {
  return moment(date).format(format);
}

export {
  downloadCsvReport
}
